import styled from '@emotion/styled'

const rotationFor = {
  up: '180deg',
  down: '0deg',
  neutral: '-90deg',
}

// Column sort indicator; `direction` is 'up' | 'down' | 'neutral'.
const SortArrow = styled(({ className }) => (
  <svg className={className} viewBox='0 0 10 10' width='10' height='10' aria-hidden='true'>
    <path d='M1.5 3.25 L5 6.75 L8.5 3.25' fill='none' stroke='currentColor' strokeWidth='2.5' />
  </svg>
))`
  flex: 0 0 auto;
  color: ${p =>
    p.direction === 'neutral'
      ? (p.theme.lightestGray ?? '#7a8e96')
      : (p.theme.darkestGray ?? '#022a3a')};
  transform: rotate(${p => rotationFor[p.direction] ?? '0deg'});
  transition:
    color 0.35s,
    transform 0.25s;
`

export { SortArrow }
